const colorCache = new Map<string, string>();

export function resolveThemeColor(color: string): string {
  const cached = colorCache.get(color);
  if (cached) {
    return cached;
  }

  const resolved = readThemeColor(color);
  if (!resolved.startsWith('var(')) {
    colorCache.set(color, resolved);
  }
  return resolved;
}

export function chartFontFamily(): string {
  if (typeof document === 'undefined') {
    return 'Roboto, sans-serif';
  }

  const value = getComputedStyle(document.documentElement)
    .getPropertyValue('--font-family-primary')
    .trim();
  return value || 'Roboto, sans-serif';
}

export function chartTextColor(): string {
  return resolveThemeColor('var(--color-text-muted)');
}

export function chartLabelColor(): string {
  return resolveThemeColor('var(--color-text-primary)');
}

export function chartGridColor(): string {
  return resolveThemeColor('var(--color-neutral-gray)');
}

export function chartTooltipBackground(): string {
  return resolveThemeColor('var(--color-bg-card)');
}

export function chartTooltipBorder(): string {
  return resolveThemeColor('var(--color-border-brand-subtle)');
}

function readThemeColor(color: string, depth = 0): string {
  if (typeof document === 'undefined' || depth > 4) {
    return color;
  }

  const match = /^var\(\s*(--[\w-]+)\s*\)$/.exec(color.trim());
  if (!match) {
    return color;
  }

  const raw = getComputedStyle(document.documentElement).getPropertyValue(match[1]).trim();
  if (!raw) {
    return color;
  }

  return readThemeColor(raw, depth + 1);
}
